import React from 'react';

import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import ButtonGroup from '@tds/core-button-group';

import { InputWrapper, DateWrapper, ButtonWrapper } from '../css';
import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';

const FilterByDates = ({ filters, setFilters }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { startDateLabel, endDateLabel, createdAt, completedAt }
  } = localizedStrings;
  return (
    <div
      style={{
        margin: '1rem 2rem',
        display: 'flex',
        flexDirection: 'column',
        gridArea: 'f-dates'
      }}
    >
      <ButtonWrapper>
        <ButtonGroup
          name="filterDates"
          label=" "
          onChange={({ target: { value } }) =>
            setFilters({ ...filters, filterCriteria: value })
          }
          value={filters.filterCriteria}
        >
          <ButtonGroup.Item value="createdAt">{createdAt}</ButtonGroup.Item>
          <ButtonGroup.Item value="validatedAt">{completedAt}</ButtonGroup.Item>
        </ButtonGroup>
      </ButtonWrapper>
      <InputWrapper>
        <DateWrapper width="162px" mr={16}>
          <DatePicker
            dateFormat="yyyy/MM/dd"
            placeholderText={startDateLabel}
            selected={filters.startDate}
            onChange={value => setFilters({ ...filters, startDate: value })}
            maxDate={new Date()}
          />
        </DateWrapper>
        <DateWrapper width="186px">
          <DatePicker
            dateFormat="yyyy/MM/dd"
            placeholderText={endDateLabel}
            maxDate={new Date()}
            selected={filters.endDate}
            onChange={value => setFilters({ ...filters, endDate: value })}
          />
        </DateWrapper>
      </InputWrapper>
    </div>
  );
};

FilterByDates.propTypes = {
  filters: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  setFilters: PropTypes.func.isRequired
};

export default FilterByDates;
